export enum USER_ROLE {
  ADMIN = 'ADMIN',
  STANDARD = 'STANDARD',
  INSPECTOR = 'INSPECTOR',
  SUPPLIER = 'SUPPLIER',
}

export enum USER_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type USER_SETTINGS_TYPE = {
  enableActivation: boolean
}

export type COMPANY_SETTING_TYPE =
  | 'inspection'
  | 'time-action'
  | 'order'
  | 'string'
  | 'user'
  | 'defect'

export type COMPANY_SETTING_NAME_INSPECTION_TYPE =
  | 'email_list_alert'
  | 'has_inspector'
  | 'supplier_can_create_inspection'
  | 'email_list'
  | 'custom_report_file_name'
  | 'email_list_submit'
  | 'email_list_approve'
  | 'show_section_group'

export type COMPANY_SETTING_NAME_TIME_ACTION_TYPE = 'extra-menus'
export type COMPANY_SETTING_NAME_STRING_TYPE = 'order'
export type COMPANY_SETTING_NAME_ORDER_TYPE =
  | 'order_item'
  | 'allow_new_order'
  | 'custom_item_breakdown'

export const COMPANY_SETTING_ENABLE_ACTIVATION = 'enable_activation' as const
export const COMPANY_SETTING_NAME_HIDE_ORDER_PROPERTIES =
  'hidden_properties' as const
export const COMPANY_SETTING_AUTO_GENERATE_PROPERTY_VALUE =
  'auto_generate_property_value' as const
export const COMPANY_SETTING_NAME_HIDE_ORDER_ACTIONS =
  'hidden_order_actions' as const

export type COMPANY_SETTING_HAS_DEFECT_AREA = 'has_defect_area'
export const COMPANY_SETTING_HAS_EXPORT_DATA = 'export_data' as const

export const COMPANY_SETTING_NAME_SUBMIT_FOR_REVIEW =
  'submit_for_review_report_types' as const

export const COMPANY_SETTING_ORDER_ADVANCE_FILTER_CUSTOM =
  'order_advance_filter_custom_column' as const

export const COMPANY_SETTING_SHOW_SECTION_GROUP = 'show_section_group' as const
export const COMPANY_SETTING_SUPPLIER_CAN_CREATE_INSPECTION =
  'supplier_can_create_inspection' as const
export const COMPANY_SETTING_FCCA_RATING = 'fcca' as const
export const COMPANY_SETTING_PRODUCTION_STATUS = 'production_status' as const
export const COMPANY_SETTING_OVERALL_RESULT = 'overall_result' as const
export const COMPANY_SETTING_SHOW_UUID = 'show_uuid' as const
export const COMPANY_SETTING_HIDDEN_BLOCKS = 'hidden_blocks' as const
export const COMPANY_SETTING_HAS_SUPPLIER = 'has_supplier' as const
export const COMPANY_SETTING_AUDIT_RATING_TITLES =
  'audit_rating_titles' as const
export const COMPANY_SETTING_PRODUCT_ADVANCE_FILTER_CUSTOM =
  'product_advance_filter_custom_column' as const

export const COMPANY_SETTING_HAS_MEASUREMENT_AQL = 'has_measurement_aql' as const

export const COMPANY_SETTING_DEFECT_STATUS = 'defect_status' as const

export const COMPANY_SETTING_REPORT_COMBINED_DEFECTS =
  'report_combined_defects' as const

export const COMPANY_SETTING_LIVEBOARD_SETTING = 'liveboard-setting' as const
